import { createFileRoute } from "@tanstack/react-router";
import { IntegrationDetail } from "@/pages/IntegrationDetail";
import { integrationPages } from "@/lib/integration-pages";
import { buildHead } from "@/lib/seo-head";

const page = integrationPages["zapsign"];
if (!page) throw new Error("Integração não cadastrada");

export const Route = createFileRoute("/contrato-por-ia-zapsign")({
  head: () => buildHead({
    title: page.metaTitle,
    description: page.metaDescription,
    path: "/contrato-por-ia-zapsign",
  }),
  component: () => <IntegrationDetail integrationKey="zapsign" />,
});
